declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: (...args: any[]) => void
  }
}

const PIXEL_ID = '920549383962578'

export function initMetaPixel() {
  // Prevent double initialization
  if (window.fbq) return

  // Meta Pixel base code
  const f = window
  const b = document
  const e = 'script'

  const n = function (...args: any[]) {
    if ((n as any).callMethod) {
      ;(n as any).callMethod.apply(n, args)
    } else {
      ;(n as any).queue.push(args)
    }
  } as any

  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = [] as any[]

  f.fbq = n
  f._fbq = n

  const script = b.createElement(e) as HTMLScriptElement
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'

  const firstScript = b.getElementsByTagName(e)[0]
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript)
  }

  // Initialize pixel
  window.fbq('init', PIXEL_ID)

  // Track PageView
  window.fbq('track', 'PageView')

  console.log(`[Meta Pixel] Initialized with ID: ${PIXEL_ID}`)
  console.log(`[Meta Pixel] PageView tracked`)
}

export function trackInitiateCheckout(source: string) {
  if (window.fbq) {
    window.fbq('track', 'InitiateCheckout', {
      content_name: 'Reset de Hinchazón en 7 Días',
      content_category: 'Ebook',
      value: 6.36,
      currency: 'USD',
      content_type: 'product',
      source: source,
    })
    console.log(`[Meta Pixel] InitiateCheckout tracked from: ${source}`)
  }
}

export function trackViewContent(sectionName: string) {
  if (window.fbq) {
    window.fbq('track', 'ViewContent', {
      content_name: sectionName,
      content_type: 'landing_page_section',
    })
    console.log(`[Meta Pixel] ViewContent tracked: ${sectionName}`)
  }
}

export function trackCustomEvent(
  eventName: string,
  data?: Record<string, any>,
) {
  if (window.fbq) {
    window.fbq('trackCustom', eventName, data)
    console.log(`[Meta Pixel] Custom event tracked: ${eventName}`, data)
  }
}
